import React, { Component } from 'react';
import loading from '../misc/loading.svg';

class Callback extends Component {

    styles = {
        div: {
            display: 'grid',
            gridTemplateColumns: 'auto',
            margin: '40vh auto 0 50%'
        }
    };

    render() {
        return (
            <div style={this.styles.div}>
                <img src={loading} alt="loading" />
            </div>
        );
    }
}

export default Callback;


// WEBPACK FOOTER //
// ./src/components/Callback.js